<template>
  <div>
    <div class="passwordResetComplete-confirm">
      <div class="grayHead">
        <span>
          パスワードが正常に変更されました。<br>
          ログイン画面にて、新しいパスワードでログインをしてください。
        </span>
      </div>
      <div class="passwordResetComplete-confirm__btnWrapper">
        <Btn
          :label="'ログイン'"
          :color="'red'"
          class="edit-btn"
          @click.native="login"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import Btn from '@/components/parts/Btn'

export default {
  name: 'PasswordForgotStep04Complete',

  components: {
    Btn
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    login () {
      this.$router.push({ name: 'Login' }).catch(() => {})
    }
  }
}
</script>

<style lang="postcss" scoped>

  .passwordResetComplete-confirm {
    height: 100%;
    overflow: auto;

    &__btnWrapper {
      margin: 100px auto 40px;
      padding: 0 15px;
      max-width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/password-forgot/Step04Complete.vue